import { useCallback } from 'react';

import { useMessage } from '@tmapy/intl';
import { SvgMail, Input, TertiaryLink } from '@tmapy/style-guide';

import type { DataComponent } from '../../types';
import { ReadOnlyFormField } from '../../components/ReadOnlyFormField';
import { msg } from '../../messages';

import { InlineViewComponentMap } from './InlineViewComponentMap';
import { stringDataConverter } from './InputComponentMap';

export const EmailInput: DataComponent = ({
  data,
  errors,
  path,
  loading,
  onChange,
  isRequired,
  isReadOnly,
  formType,
}) => {
  const formatMessage = useMessage();

  const handleChange = useCallback(
    (e: React.ChangeEvent, eventData: { value: any }) => {
      const value = stringDataConverter.fromText(eventData.value);
      onChange?.(value);
    },
    [onChange],
  );

  const value = stringDataConverter.toText(data);

  return isReadOnly ? (
    <ReadOnlyFormField>
      <InlineViewComponentMap.Email
        loading={loading}
        data={value}
        errors={errors}
        path={path}
        variables={null}
        isReadOnly
        isRequired={isRequired}
      />
    </ReadOnlyFormField>
  ) : (
    <Input
      type='email'
      value={value}
      isRequired={isRequired}
      isReadOnly={isReadOnly}
      isInvalid={!!errors.length}
      isDisabled={loading}
      onChange={handleChange}
    >
      {formType !== 'new' && value && (
        <TertiaryLink
          icon={{ element: <SvgMail /> }}
          tooltip={formatMessage(msg.sendEmail, { email: value })}
          href={`mailto:${value}`}
        />
      )}
    </Input>
  );
};
